module.exports = __webpack_public_path__ + "static/media/speaker-icon.e9f6ad3e.png";